// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Mqh-","col":"Table_col__2oM0Q","fulfillmentStatus":"Table_fulfillmentStatus__1oWV6","emailCol":"Table_emailCol__2MqA7"};